import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OidcClientService } from "@upmc-healthplan-npm/oidc-client";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private auth: OidcClientService,
    private router: Router,
  ) {}
  canActivate(): Observable<boolean> {
    const unsubscribe = new Subject();
    return new Observable((observer) => {
      this.auth
        .getUserComputed()
        .pipe(takeUntil(unsubscribe))
        .subscribe((userComputed) => {
          if (userComputed) {
            const userRole = JSON.parse(
              sessionStorage.getItem("userRole"),
            ).role;
            const broker = JSON.parse(
              sessionStorage.getItem("userRole"),
            ).permissions;
            if (userRole && broker.length > 0) {
              observer.next(true);
            } else {
              this.router.navigate(["/unauthorized"]);
              observer.next(false);
            }
          } else {
            observer.next(false);
            this.auth.signIn();
          }
          unsubscribe.next();
        });
    });
  }
}
